import React from 'react'

import { setGable14UnavailableModalOpen, setSelectedToolbarTabIndex } from '../../store/ui/uiSlice'
import Modal from '../Modal/Modal'
import Heading from '../Heading/Heading'

import * as commonStyles from '../styles'
import * as styles from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

const Gable14UnavailableModal: React.FC = () => {
  const { isGable14UnavailableModalOpen } = useAppSelector((state) => state.ui) || {}
  const { content } = useAppSelector((state) => state.init) || {}
  const dispatch = useAppDispatch()

  const sizeTabIndex = 0

  const closeGable14UnavailableModal = (): void => {
    dispatch(setSelectedToolbarTabIndex(sizeTabIndex))
    dispatch(setGable14UnavailableModalOpen(false))
  }

  return (
    <Modal
      isOpen={isGable14UnavailableModalOpen}
      onRequestClose={closeGable14UnavailableModal}
      contentLabel={content?.modals?.backPrompt?.title} // only for screenreaders
    >
      <Styled.ModalBackPrompt>
        <Heading level={2}>{content?.modals?.roofUnavailable?.gable14?.title}</Heading>
        <p>{content?.modals?.roofUnavailable?.gable14?.information}</p>
        <Styled.Button className="button-secondary" onClick={closeGable14UnavailableModal}>
          {content?.modals?.roofUnavailable?.cancel}
        </Styled.Button>
        <Styled.Button className="button-primary" onClick={closeGable14UnavailableModal}>
          {content?.modals?.roofUnavailable?.ok}
        </Styled.Button>
      </Styled.ModalBackPrompt>
    </Modal>
  )
}

export default Gable14UnavailableModal
